export default {
  en: {
    title: 'Network - visualisation',
    pageHeader: 'Network',
    visualisationHeaderName: 'Visualisation',
    error: 'Failed to load the network. Please try again.',
    nthDegree: {
      '1': '<b>{count}</b> sub-entity | <b>{count}</b> sub-entities',
      '2': '<b>{count}</b> supplier | <b>{count}</b> suppliers',
      '3': '<b>{count}</b> {ordinal} party supplier | <b>{count}</b> {ordinal} party suppliers',
    },
    ordinalNumber: '{number}{ordinal}',
    ordinals: {
      zero: 'n/a',
      one: 'st',
      two: 'nd',
      few: 'rd',
      many: 'n/a',
      other: 'th',
    },
    concentrationRisks:
      '<b>{count}</b> potential concentration risk | <b>{count}</b> potential concentration risks',
    potentialConcentrationRisk: 'Potential concentration risk',
    suppliers: '<b>{count}</b> supplier | <b>{count}</b> suppliers',
    viewProfile: 'View profile',
    openRisk: 'Open risk',
    nav: {
      visualisation: 'Visualisation',
      dataTable: 'Data table',
    },
    table: {
      title: 'Network - table view',
      headerName: 'Table view',
      emptyTitle: 'Organisations',
      emptyDescription: 'No organisations could be found',
      errorTitle: 'Organisations',
      errorDescription: 'Failed fetching organisations',
      entityName: 'Organisation',
      results: '{count} organisation | {count} organisations',
      resultsOutOf: '{0} out of {1}',
      isPotentialConcentrationRisk: 'Potential concentration risk',
      anonymisedSupplierCount: '{count} anonymised supplier | {count} anonymised suppliers',
      filters: {
        name: 'Name',
        degree: 'Degree',
        numClients: 'No. of clients',
        clientNames: 'Client names',
        supplierNames: 'Supplier names',
        numSuppliers: 'No. of suppliers',
        potentialConcentrationRisk: 'Potential concentration risk',
        isRisk: 'Is potential concentration risk',
        isNotRisk: 'Is not potential concentration risk',
        sector: 'Sector',
        country: 'Location',
      },
      columns: {
        name: 'Organisation',
        degree: 'Degree',
        numClients: 'No. of clients',
        numSuppliers: 'No. of suppliers',
        clientNames: 'Client names',
        supplierNames: 'Supplier names',
        potentialConcentrationRisk: 'Potential concentration risk',
        sector: 'Sector',
        country: 'Location',
        actions: 'Actions',
      },
      degrees: {
        '1': 'Sub-entity',
        '2': 'Supplier',
        nthParty: '{ordinal} party supplier',
      },
      actions: {
        view: 'View',
      },
      export: 'Export',
      exportError: 'There was an error attempting to export the network data table',
      exportTitle: 'Network-Data-Table',
    },
  },
};
